module.exports = __webpack_public_path__ + "static/media/Little Buddies.8ff7c04b.png";